/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import Backend from 'i18next-http-backend';
import { configurationPath } from '../../settings';
import configurationApi from '../../api/configuration.api';

export default class ConfigurableI18nBackend extends Backend {
  constructor(services, options = {}, allOptions = {}) {
    super(services, options, allOptions);
  }

  loadUrl(url, callback, languages, namespaces) {
    configurationApi.getResource(`${configurationPath}/configuration/versions/default`).then((version) => {
      this.loadVersionUrl(version, url, callback, languages, namespaces);
    });
  }

  loadVersionUrl(version, url, callback, languages, namespaces) {
    const versionResourceUrl = `${configurationPath}/fo/configuration/${version.id}${url}`;
    super.loadUrl(versionResourceUrl, callback, languages, namespaces);
  }
}
